import React, { useEffect, useState } from 'react';
import { setProgressBarPercentage, useAppDispatch } from 'src/common';
import { Button, Flex, InputBirthDate } from 'src/components';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from './_router/app.routes';

const RootPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setProgressBarPercentage(20));
  }, []);

  const [dateOfBirth, setDateOfBirth] = useState<string>('');

  return (
    <Flex justify='center' align='center' style={{ height: '100vh' }}>
      <InputBirthDate onChange={(value: string) => setDateOfBirth(value) } id='1' />
      <Button onClick={() => navigate(`${AppRoutes.CUSTOMER_DATE.fullPath}/${dateOfBirth}`)}>Potvrdi</Button>
    </Flex>
  );
}

export default RootPage;
